/**

 **/
define(function (require) {
    "use strict";

    var $ = require("jquery");
    var _ = require("underscore");
    var Backbone = require("backbone");
    var Marionette = require("marionette");
    var Translator = require("i18n/translator");
    var template = require('ui.plugins/gridView/filter/filter-types/templates/multiselectFilter.tmpl');
    var Logger = require('logger');
    var Multiselect = require("ui/multiselect/Multiselect");


    var MultiselectFilter = Marionette.ItemView.extend({
        className: "multiselect-filter-container",
        template: template,
        ui: {
            multiselectInput: ".filter-input-container"
        },
        uiComponents: {
            multiselectInput: {
                type: Multiselect,
                options: "_getMultiselectOptions",
                events: "_getMultiselectEvents"
            }
        },

        initialize: function(options) {
            this.logger = Logger.getLogger("MultiselectFilter");
            this.selectedValues = options.selectedValues || [];
            if(options.filterData){
                if(options.filterData.valuesArr){
                    this.valuesArr = options.filterData.valuesArr;
                }
                else{
                    this.logger.error("Missing valuesArr","MultiselectFilter:initialize");
                    this.logger.graph({ name: "UIComponents:MultiselectFilter:MissingValuesArr"});
                }
                this.placeholderText = options.filterData.placeholderText || "";
                this.noResultsText = options.filterData.noResultsText || Translator.translate("LEUIComponents.gridView.filter.multiselect.noResults");
                this.componentOptions = options.filterData.componentOptions || {};
                this.componentEvents = options.filterData.componentEvents || {};
            }
            else{
                this.logger.error("Missing filterData","MultiselectFilter:initialize");
                this.logger.graph({ name: "UIComponents:MultiselectFilter:MissingFilterData"});
            }

            this.saveFullData = options.filterData.saveFullData;
            this.selectedValuesCollection = new Backbone.Collection(this.selectedValues);
        },

        _getMultiselectOptions: function() {
            var defaultOptions = {
                container: this.ui.multiselectInput,
                permutation: Multiselect.PERMUTATION.FULL,
                trim: true,
                items: this.valuesArr,
                floating: false,
                selectedItems: this.selectedValues,
                list: {
                    maxShownItems: 5,
                    noItems: {
                        visible: true,
                        value: this.noResultsText
                    }
                },
                tagsContainer: {
                    placeholder: this.placeholderText,
                    maxShownLines: 5,
                    inlineErrorText: "",
                    tagMaxWidth: "150px"
                }
            };

            var mergedOptions = $.extend({}, defaultOptions, this.componentOptions);
            return mergedOptions;
        },

        _getMultiselectEvents: function() {
            var defaultEvents = {};
            if (this.saveFullData) {
                defaultEvents = {
                    "select": "_onSelect",
                    "unselect": "_onUnselect"
                };
            }
            var mergedEvents = $.extend({}, defaultEvents, this.componentEvents);

            return mergedEvents;
        },

        _onSelect: function(componentId, eventName, item) {
            if (this.saveFullData) {
                this.selectedValuesCollection.add(item);
            }
        },

        _onUnselect: function(componentId, eventName, item) {
            if (this.saveFullData) {
                this.selectedValuesCollection.remove(item);
            }
        },

        getFilterSelection: function() {
            if (this.saveFullData) {
                return this.selectedValuesCollection.toJSON();
            }
            else {
                return this.uiComponents.multiselectInput.getSelectedItems();
            }
        },

        resetCollectionFilter: function() {
            this.selectedValuesCollection.reset([]);
            this.uiComponents.multiselectInput.unselectAll();
            return this.getFilterSelection();
        }
    });

    return MultiselectFilter;
});
